const ADMIN_ROLES = ['regional_admin', 'admin', 'readonly_admin'];

export function isAdmin(user): boolean {
  return !!user.roles.find((role) => ADMIN_ROLES.indexOf(role.name) !== -1);
}
